
import React from "react";

const LoadingSpinner: React.FC = () => {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-toctoc-blue mb-4"></div>
      <p className="text-gray-500 ml-3">Carregando...</p>
    </div>
  );
};

export default LoadingSpinner;
